interface CrmAccessUser {
  email?: string | null;
  role?: string | null;
}

export const canAccessCrm = (user?: CrmAccessUser | null): boolean => {
  return !!user;
};

const TERRITORIAL_ALLOWED_EMAIL = 'eliton_marcio@yahoo.com.br';

export const canAccessTerritorial = (user?: CrmAccessUser | null): boolean => {
  if (!user) return false;

  if (user.role === 'SUPERADMIN') {
    return true;
  }

  return (user.email || '').trim().toLowerCase() === TERRITORIAL_ALLOWED_EMAIL;
};
